import React, { Suspense } from 'react';
import { useAtomValue } from 'jotai';
import { restaurantAtom } from '../store/restaurant';
import SelectRestaurant from './Sidebar/components/SelectRestaurant';
import { Outlet } from 'react-router-dom';

const RestaurantLevelLayout = () => {
  const restaurant = useAtomValue(restaurantAtom);

  return (
    <Suspense>
      <div className="h-full flex flex-col">
        <div className="mt-6 mx-6">
          <SelectRestaurant />
        </div>
        {restaurant ? (
          <div className="flex-1 w-full">
            <Outlet />
          </div>
        ) : (
          <div className="flex items-center justify-center h-full text-lg">
            Pilih restoran terlebih dahulu
          </div>
        )}
      </div>
    </Suspense>
  );
};

export default RestaurantLevelLayout;
